import { Hero } from "@/components/home/Hero";
import "./index.css";

export function App() {
  return (
    <div className="h-dvh overflow-hidden">
      <Hero />
    </div>
  );
}

export default App;
